webpackJsonp([29],{

/***/ 1815:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1816);


/***/ }),

/***/ 1816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _scrolltoErrors = __webpack_require__(1817);

var _scrolltoErrors2 = _interopRequireDefault(_scrolltoErrors);

var _authenticationModal = __webpack_require__(1818);

var _authenticationModal2 = _interopRequireDefault(_authenticationModal);

var _userRegistration = __webpack_require__(1821);

var _userRegistration2 = _interopRequireDefault(_userRegistration);

var _userAuthentication = __webpack_require__(1822);

var _userAuthentication2 = _interopRequireDefault(_userAuthentication);

__webpack_require__(1823);

__webpack_require__(1824);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
    if ($('#authentication-modal').length) {
        _authenticationModal2.default.attachTo(document);
        _userRegistration2.default.attachTo(document);
        _userAuthentication2.default.attachTo(document);
    }

    _scrolltoErrors2.default.attachTo(document);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 1817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _flightjs = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ScrollToErrors() {
    this.scroll = function (e, options) {
        var $errors = this.$node.find('[data-field-error]');
        options = _jquery2.default.extend({}, options, {
            duration: 0
        });

        if ($errors.length > 0) {
            var $firstError = $errors.first();
            (0, _jquery2.default)('html, body').animate({
                scrollTop: $firstError.offset().top
            }, options.duration);
        }
    };

    this.after('initialize', function () {
        this.scroll();
        this.on(document, 'errorsPopulated', this.scroll);
    });
}

exports.default = (0, _flightjs.component)(ScrollToErrors);

/***/ }),

/***/ 1818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _flightjs = __webpack_require__(6);

var _loginForm = __webpack_require__(1819);

var _loginForm2 = _interopRequireDefault(_loginForm);

var _registrationForm = __webpack_require__(1820);

var _registrationForm2 = _interopRequireDefault(_registrationForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Authentication() {
    var source;
    var pending = false;

    this.attributes({
        triggerSelector: '#authentication-modal-trigger',
        loginFormSelector: '#login-form',
        registerFormSelector: '#registration-form',
        showRegisterSelector: '#login-form .classic-modal__description a',
        showLoginSelector: '#registration-form .classic-modal__description a'
    });

    this.setupModal = function () {
        (0, _jquery2.default)(document).on('modal:beforeHide:authentication', function (e, modal) {
            if (pending) {
                modal.stop();
            } else {
                modal.proceed();
            }
        });
    };

    this.authenticationRequested = function (e, data) {
        if (data && data.source) {
            source = data.source;
        }

        this.select('triggerSelector').data('modal').show();
    };

    this.authenticationSuccessful = function () {
        this.select('triggerSelector').data('modal').hide();
        this.trigger('authenticationSuccessful', {
            source: source
        });
    };

    this.showRegistrationForm = function (e) {
        e.preventDefault();
        if (pending) {
            return;
        }
        this.select('registerFormSelector').show();
        this.select('loginFormSelector').hide();
    };

    this.showLoginForm = function (e) {
        e.preventDefault();
        if (pending) {
            return;
        }
        this.select('registerFormSelector').hide();
        this.select('loginFormSelector').show();
    };

    this.requestPending = function () {
        pending = true;
    };

    this.requestFinished = function () {
        pending = false;
    };

    this.after('initialize', function () {
        this.setupModal();

        _loginForm2.default.attachTo('#loginform');
        _registrationForm2.default.attachTo('#registrationform');

        this.on('click', {
            showRegisterSelector: this.showRegistrationForm,
            showLoginSelector: this.showLoginForm
        });

        this.on('authenticationRequested', this.authenticationRequested);
        this.on('loginSuccessful', this.authenticationSuccessful);
        this.on('registrationSuccessful', this.authenticationSuccessful);
        this.on('spinnerStart', this.requestPending);
        this.on('spinnerStop', this.requestFinished);
    });
}

exports.default = (0, _flightjs.component)(Authentication);

/***/ }),

/***/ 1819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _flightjs = __webpack_require__(6);

var _withAsyncValidation = __webpack_require__(752);

var _withAsyncValidation2 = _interopRequireDefault(_withAsyncValidation);

var _buttonSpinner = __webpack_require__(532);

var _buttonSpinner2 = _interopRequireDefault(_buttonSpinner);

var _cookiesJs = __webpack_require__(745);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lang = {
    enterEmail: 'Please enter an email address',
    enterPassword: 'Please enter a password',
    error: 'Invalid email or password'
};

function LoginForm() {
    this.attributes({
        submitSelector: '[type="submit"]',
        emailSelector: '#loginform_email',
        passwordSelector: '#loginform_password'
    });

    this.submitClicked = function (e) {
        e.preventDefault();
        this.resetValidationErrors();

        var $email = this.select('emailSelector');
        var $password = this.select('passwordSelector');

        if (!$email.val()) {
            this.displayErrorsForField($email, lang.enterEmail);
            return;
        }

        if (!$password.val()) {
            this.displayErrorsForField($password, lang.enterPassword);
            return;
        }

        this.trigger('spinnerStart');

        var data = {
            email: $email.val(),
            password: $password.val(),
            csrf_token: (0, _cookiesJs.get)('_99csrf')
        };

        if (_jquery2.default.jqbrowser) {
            data.browser = _jquery2.default.jqbrowser.browser();
            data.browserversion = _jquery2.default.jqbrowser.version.string();
            data.operatingsystem = _jquery2.default.jqbrowser.OS();
        }

        data.screenresolution = screen.width + 'x' + screen.height;
        data.timezoneoffset = new Date().getTimezoneOffset();

        this.trigger('uiUserAuthenticationRequested', data);
    };

    this.handleAuthenticationSuccess = function () {
        this.trigger('spinnerStop');
        this.trigger('loginSuccessful');
    };

    this.handleAuthenticationFailure = function () {
        var $email = this.select('emailSelector');
        this.trigger('spinnerStop');

        this.displayErrorsForField($email, lang.error);
    };

    this.prePopulateEmail = function (e, data) {
        this.select('emailSelector').val(data.value);
    };

    this.after('initialize', function () {
        _buttonSpinner2.default.attachTo(this.select('submitSelector'));

        this.on('click', {
            submitSelector: this.submitClicked
        });

        this.on(document, 'uiBriefEmailBeforeSignupChanged', this.prePopulateEmail);
        this.on(document, 'dataUserAuthenticationSuccess', this.handleAuthenticationSuccess);
        this.on(document, 'dataUserAuthenticationFailure', this.handleAuthenticationFailure);
    });
}

exports.default = (0, _flightjs.component)(LoginForm, _withAsyncValidation2.default);

/***/ }),

/***/ 1820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(6);

var _withAsyncValidation = __webpack_require__(752);

var _withAsyncValidation2 = _interopRequireDefault(_withAsyncValidation);

var _buttonSpinner = __webpack_require__(532);

var _buttonSpinner2 = _interopRequireDefault(_buttonSpinner);

var _cookiesJs = __webpack_require__(745);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lang = {
    enterEmail: 'Please enter an email address',
    enterPassword: 'Please enter a password',
    passwordMismatch: 'Password fields must match',
    invalidEmail: 'Your email address is invalid',
    invalidPassword: '',
    emailTaken: 'This email address is taken',
    genericError: 'Unable to register, please try again'
};

function RegistrationForm() {
    this.attributes({
        submitSelector: '[type="submit"]',
        emailSelector: '#registrationform_email',
        passwordSelector: '#registrationform_password_first',
        passwordConfirmSelector: '#registrationform_password_second',
        privacyAndTermsCheckbox: '[data-privacy-and-terms-agreement]',
        context: 'launch'
    });

    this.toggleSubmitButton = function (_ref) {
        var target = _ref.target;

        this.select('submitSelector').attr('disabled', !target.checked);
    };

    this.submitClicked = function (e) {
        e.preventDefault();

        var hasAgreedToPrivacyAndTerms = this.select('privacyAndTermsCheckbox')[0].checked;
        if (!hasAgreedToPrivacyAndTerms) {
            return;
        }

        this.resetValidationErrors();

        var $email = this.select('emailSelector');
        var $password = this.select('passwordSelector');
        var $confirmPassword = this.select('passwordConfirmSelector');

        if (!$email.val()) {
            this.displayErrorsForField($email, lang.enterEmail);
            return;
        }

        if (!$password.val()) {
            this.displayErrorsForField($password, lang.enterPassword);
            return;
        }

        if ($password.val() !== $confirmPassword.val()) {
            this.displayErrorsForField($confirmPassword, lang.passwordMismatch);
            return;
        }

        this.trigger('spinnerStart');

        var data = {
            email: this.select('emailSelector').val(),
            password: this.select('passwordSelector').val(),
            context: this.attr.context,
            csrf_token: (0, _cookiesJs.get)('_99csrf'),
            source: 'contests_launch',
            legals: hasAgreedToPrivacyAndTerms
        };

        this.trigger('uiUserRegistrationRequested', data);
    };

    this.handleRegistrationSuccess = function (ev, data) {
        this.trigger('spinnerStop');
        this.trigger('registrationSuccessful');
    };

    this.handleRegistrationFailure = function (ev, data) {
        var $email = this.select('emailSelector');
        var $password = this.select('passwordSelector');
        var errors = {};

        if (data && data.errors) {
            errors = this.formErrors(data.errors);
        }

        this.trigger('spinnerStop');

        if (errors.email) {
            this.displayErrorsForField($email, errors.email);
        } else if (errors.password) {
            this.displayErrorsForField($password, errors.password);
        } else {
            this.displayErrorsForField($email, lang.genericError);
        }
    };

    this.formErrors = function (errors) {
        var fieldErrors = {};

        if (!errors) {
            return fieldErrors;
        }

        errors.forEach(function (error) {
            if (!fieldErrors[error.param]) {
                fieldErrors[error.param] = error.message;
            }
        });

        return fieldErrors;
    };

    this.prePopulateEmail = function (e, data) {
        this.select('emailSelector').val(data.value);
    };

    this.after('initialize', function () {
        this.select('emailSelector').parents('.field').append('<div id="email-suggestion-container" class="field__message" />');
        this.select('emailSelector').setupMailCheck('#email-suggestion-container');

        _buttonSpinner2.default.attachTo(this.select('submitSelector'));

        this.on('click', {
            privacyAndTermsCheckbox: this.toggleSubmitButton
        });

        this.on('submit', this.submitClicked);

        this.on(document, 'uiBriefEmailBeforeSignupChanged', this.prePopulateEmail);
        this.on(document, 'dataUserRegistrationSuccess', this.handleRegistrationSuccess);
        this.on(document, 'dataUserRegistrationFailure', this.handleRegistrationFailure);
    });
}

exports.default = (0, _flightjs.component)(RegistrationForm, _withAsyncValidation2.default);

/***/ }),

/***/ 1821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(6);

var UserRegistration = function UserRegistration() {
    this.attributes({
        endpoint: '/accounts/xhr/signup'
    });

    this.after('initialize', function () {
        this.on(document, 'uiUserRegistrationRequested', this.sendRegistrationRequest);
        this.on('dataUserRegistrationSuccess', this.trackSignup);
    });

    this.trackSignup = function (e, data) {
        if (window.analytics) {
            window.analytics.alias(data.userid);
            window.analytics.identify(data.userid);
            window.analytics.track('Launch Signup');
        }
    };

    this.sendRegistrationRequest = function (e, data) {
        var xhr = $.ajax({
            url: this.attr.endpoint,
            method: 'post',
            data: JSON.stringify(data),
            contentType: 'application/json'
        });

        xhr.done(function (res) {
            this.trigger('dataUserRegistrationSuccess', res);
        }.bind(this));

        xhr.error(function (res) {
            this.trigger('dataUserRegistrationFailure', res.responseJSON);
        }.bind(this));
    };
};

exports.default = (0, _flightjs.component)(UserRegistration);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 1822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(6);

var UserAuthentication = function UserAuthentication() {
    this.attributes({
        endpoint: '/accounts/xhr/login'
    });

    this.after('initialize', function () {
        this.on(document, 'uiUserAuthenticationRequested', this.sendAuthenticationRequest);
    });

    this.sendAuthenticationRequest = function (e, data) {
        var xhr = $.ajax({
            url: this.attr.endpoint,
            method: 'post',
            data: JSON.stringify(data),
            contentType: 'application/json'
        });

        xhr.done(function (res) {
            this.trigger('dataUserAuthenticationSuccess');
        }.bind(this));

        xhr.error(function (res) {
            this.trigger('dataUserAuthenticationFailure');
        }.bind(this));
    };
};

exports.default = (0, _flightjs.component)(UserAuthentication);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 1823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

/**
 * jQBrowser v0.2 - Extend jQuery's browser detection capabilities
 *   * http://davecardwell.co.uk/javascript/jquery/plugins/jquery-browserdetect/0.2/
 *
 * Dave Cardwell <http://davecardwell.co.uk/>
 *
 * Built on the shoulders of giants:
 *   * John Resig <http://jquery.com/>
 *   * Peter-Paul Koch <http://www.quirksmode.org/?/js/detect.html>
 *
 *
 * Copyright (c) 2006 Dave Cardwell, dual licensed under the MIT and GPL
 * licenses:
 *   * http://www.opensource.org/licenses/mit-license.php
 *   * http://www.gnu.org/licenses/gpl.txt
 */

/**
 * For the latest version of this plugin, and a discussion of its usage and
 * implementation, visit:
 *   * http://davecardwell.co.uk/javascript/jquery/plugins/jquery-browserdetect/
 */

new function () {
    /**
     * The following functions and attributes form the Public interface of the
     * jQBrowser plugin, accessed externally through the $.browser object.
     * See the relevant function definition later in the source for further
     * information.
     *
     * $.browser.browser()
     * $.browser.version.number()
     * $.browser.version.string()
     * $.browser.OS()
     *
     * $.browser.aol()
     * $.browser.camino()
     * $.browser.firefox()
     * $.browser.flock()
     * $.browser.icab()
     * $.browser.konqueror()
     * $.browser.mozilla()
     * $.browser.msie()
     * $.browser.netscape()
     * $.browser.opera()
     * $.browser.safari()
     *
     * $.browser.linux()
     * $.browser.mac()
     * $.browser.win()
     */
    var Public = {
        // The current browser, its version as a number or a string, and the
        // operating system its running on.
        'browser': function browser() {
            return Private.browser;
        },
        'version': {
            'number': function number() {
                return Private.version.number;
            },
            'string': function string() {
                return Private.version.string;
            }
        },
        'OS': function OS() {
            return Private.OS;
        },

        // A boolean value indicating whether or not the given browser was
        // detected.
        'aol': function aol() {
            return Private.aol;
        },
        'camino': function camino() {
            return Private.camino;
        },
        'firefox': function firefox() {
            return Private.firefox;
        },
        'flock': function flock() {
            return Private.flock;
        },
        'icab': function icab() {
            return Private.icab;
        },
        'konqueror': function konqueror() {
            return Private.konqueror;
        },
        'mozilla': function mozilla() {
            return Private.mozilla;
        },
        'msie': function msie() {
            return Private.msie;
        },
        'netscape': function netscape() {
            return Private.netscape;
        },
        'opera': function opera() {
            return Private.opera;
        },
        'safari': function safari() {
            return Private.safari;
        },
        'chrome': function chrome() {
            return Private.chrome;
        },

        // A boolean value indicating whether or not the given OS was
        // detected.
        'linux': function linux() {
            return Private.linux;
        },
        'mac': function mac() {
            return Private.mac;
        },
        'win': function win() {
            return Private.win;
        }
    };

    // Allow external access to the 'Public' interface through the $.browser
    // object.
    $.jqbrowser = Public;

    /**
     * The following functions and attributes form the internal methods and
     * state of the jQBrowser plugin.  See the relevant function definition
     * later in the source for further information.
     *
     * Private.browser
     * Private.version
     * Private.OS
     *
     * Private.aol
     * Private.camino
     * Private.firefox
     * Private.flock
     * Private.icab
     * Private.konqueror
     * Private.mozilla
     * Private.msie
     * Private.netscape
     * Private.opera
     * Private.safari
     *
     * Private.linux
     * Private.mac
     * Private.win
     */
    var Private = {
        // Initially set to 'Unknown', if detected each of these properties will
        // be updated.
        'browser': 'Unknown',
        'version': {
            'number': undefined,
            'string': 'Unknown'
        },
        'OS': 'Unknown',

        // Initially set to false, if detected one of the following browsers
        // will be updated.
        'aol': false,
        'camino': false,
        'firefox': false,
        'flock': false,
        'icab': false,
        'konqueror': false,
        'mozilla': false,
        'msie': false,
        'netscape': false,
        'opera': false,
        'safari': false,
        'chrome': false,

        // Initially set to false, if detected one of the following operating
        // systems will be updated.
        'linux': false,
        'mac': false,
        'win': false
    };

    /**
     * Loop over the items in 'data' trying to find a browser match with the
     * test in data[i].browser().  Once found, attempt to determine the
     * browser version.
     *
     *       'name': A string containing the full name of the browser.
     * 'identifier': By default this is a lowercase version of 'name', but
     *               this can be overwritten by explicitly defining an
     *               'identifier'.
     *    'browser': A function that returns a boolean value indicating
     *               whether or not the given browser is detected.
     *    'version': An optional function that overwrites the default version
     *               testing.  Must return the result of a .match().
     *
     * Please note that the order of the data array is important, as some
     * browsers contain details of others in their navigator.userAgent string.
     * For example, Flock's contains 'Firefox' so much come before Firefox's
     * test to avoid false positives.
     */
    for (var i = 0, // counter
    ua = navigator.userAgent, // the navigator's user agent string
    ve = navigator.vendor, // the navigator's vendor string
    data = [// browser tests and data
    { // Safari <http://www.apple.com/safari/>
        'name': 'Safari',
        'browser': function browser() {
            return (/Apple/.test(ve)
            );
        }
    }, { // Opera <http://www.opera.com/>
        'name': 'Opera',
        'browser': function browser() {
            return window.opera != undefined;
        }
    }, { // iCab <http://www.icab.de/>
        'name': 'iCab',
        'browser': function browser() {
            return (/iCab/.test(ve)
            );
        }
    }, { // Konqueror <http://www.konqueror.org/>
        'name': 'Konqueror',
        'browser': function browser() {
            return (/KDE/.test(ve)
            );
        }
    }, { // AOL Explorer <http://downloads.channel.aol.com/browser>
        'identifier': 'aol',
        'name': 'AOL Explorer',
        'browser': function browser() {
            return (/America Online Browser/.test(ua)
            );
        },
        'version': function version() {
            return ua.match(/rev(\d+(?:\.\d+)+)/);
        }
    }, { // Flock <http://www.flock.com/>
        'name': 'Flock',
        'browser': function browser() {
            return (/Flock/.test(ua)
            );
        }
    }, { // Camino <http://www.caminobrowser.org/>
        'name': 'Camino',
        'browser': function browser() {
            return (/Camino/.test(ve)
            );
        }
    }, { // Firefox <http://www.mozilla.com/firefox/>
        'name': 'Firefox',
        'browser': function browser() {
            return (/Firefox/.test(ua)
            );
        }
    }, { // Netscape <http://browser.netscape.com/>
        'name': 'Netscape',
        'browser': function browser() {
            return (/Netscape/.test(ua)
            );
        }
    }, { // Internet Explorer <http://www.microsoft.com/windows/ie/>
        //                   <http://www.microsoft.com/mac/ie/>
        'identifier': 'msie',
        'name': 'Internet Explorer',
        'browser': function browser() {
            return (/MSIE/.test(ua)
            );
        },
        'version': function version() {
            return ua.match(/MSIE (\d+(?:\.\d+)+(?:b\d*)?)/);
        }
    }, { // Chrome <www.google.com/chrome/>
        'name': 'Chrome',
        'browser': function browser() {
            return (/Chrome/.test(ua)
            );
        }
    }, { // Mozilla <http://www.mozilla.org/products/mozilla1.x/>
        'name': 'Mozilla',
        'browser': function browser() {
            return (/Gecko|Mozilla/.test(ua)
            );
        },
        'version': function version() {
            return ua.match(/rv:(\d+(?:\.\d+)+)/);
        }
    }]; i < data.length; i++) {
        if (data[i].browser()) {
            // we have a match
            // If the identifier is not explicitly set, use a lowercase
            // version of the given name.
            var identifier = data[i].identifier ? data[i].identifier : data[i].name.toLowerCase();

            // Make a note that this browser was detected.
            Private[identifier] = true;

            // $.browser.browser() will now return the correct browser.
            Private.browser = data[i].name;

            var result;
            if (data[i].version != undefined && (result = data[i].version())) {
                // Use the explicitly set test for browser version.
                Private.version.string = result[1];
                Private.version.number = parseFloat(result[1]);
            } else {
                // Otherwise use the default test which searches for the
                // version number after the browser name in the user agent
                // string.
                var re = new RegExp(data[i].name + '(?:\\s|\\/)(\\d+(?:\\.\\d+)+(?:(?:a|b)\\d*)?)');

                result = ua.match(re);
                if (result != undefined) {
                    Private.version.string = result[1];
                    Private.version.number = parseFloat(result[1]);
                }
            }

            // Once we've detected the browser there is no need to check the
            // others.
            break;
        }
    };

    /**
     * Loop over the items in 'data' trying to find a operating system match
     * with the test in data[i].os().
     *
     *       'name': A string containing the full name of the operating
     *               system.
     * 'identifier': By default this is a lowercase version of 'name', but
     *               this can be overwritten by explicitly defining an
     *               'identifier'.
     *         'OS': A function that returns a boolean value indicating
     *               whether or not the given operating system is detected.
     */
    for (var i = 0, // counter
    pl = navigator.platform, // the navigator's platform string
    data = [// OS data and tests
    { // Microsoft Windows <http://www.microsoft.com/windows/>
        'identifier': 'win',
        'name': 'Windows',
        'OS': function OS() {
            return (/Win/.test(pl)
            );
        }
    }, { // Apple Mac OS <http://www.apple.com/macos/>
        'name': 'Mac',
        'OS': function OS() {
            return (/Mac/.test(pl)
            );
        }
    }, { // Linux <http://www.linux.org/>
        'name': 'Linux',
        'OS': function OS() {
            return (/Linux/.test(pl)
            );
        }
    }]; i < data.length; i++) {
        if (data[i].OS()) {
            // we have a match
            // If the identifier is not explicitly set, use a lowercase
            // version of the given name.
            var identifier = data[i].identifier ? data[i].identifier : data[i].name.toLowerCase();

            // Make a note that the OS was detected.
            Private[identifier] = true;

            // $.browser.OS() will now return the correct OS.
            Private.OS = data[i].name;

            // Once we've detected the browser there is no need to check the
            // others.
            break;
        }
    };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 1824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * Mailcheck https://github.com/Kicksend/mailcheck
 * Author
 * Derrick Ko (@derrickko)
 *
 * License
 * Copyright (c) 2012 Receivd, Inc.
 *
 * Licensed under the MIT License.
 *
 * v 1.0.3
 */
(function (b) {
    b.fn.mailcheck = function (a, b) {
        var d = "".split(","),
            e = "".split(",");if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && void 0 === b) a.domains = a.domains || d;else {
            var g = a,
                a = b;a.domains = g || d;
        }a.topLevelDomains = a.topLevelDomains || e;a.distanceFunction = Kicksend.sift3Distance;(d = Kicksend.mailcheck.suggest(encodeURI(this.val()), a.domains, a.topLevelDomains, a.distanceFunction)) ? a.suggested && a.suggested(this, d) : a.empty && a.empty(this);
    };
})(jQuery);
var Kicksend = { mailcheck: { threshold: 3, suggest: function suggest(b, a, c, d) {
            b = b.toLowerCase();b = this.splitEmail(b);if (a = this.findClosestDomain(b.domain, a, d)) {
                if (a != b.domain) return { address: b.address, domain: a, full: b.address + "@" + a };
            } else if (c = this.findClosestDomain(b.topLevelDomain, c), b.domain && c && c != b.topLevelDomain) return a = b.domain, a = a.substring(0, a.lastIndexOf(b.topLevelDomain)) + c, { address: b.address, domain: a, full: b.address + "@" + a };return !1;
        }, findClosestDomain: function findClosestDomain(b, a, c) {
            var d,
                e = 99,
                g = null;if (!b || !a) return !1;
            c || (c = this.sift3Distance);for (var f = 0; f < a.length; f++) {
                if (b === a[f]) return b;d = c(b, a[f]);d < e && (e = d, g = a[f]);
            }return e <= this.threshold && null !== g ? g : !1;
        }, sift3Distance: function sift3Distance(b, a) {
            if (null == b || 0 === b.length) return null == a || 0 === a.length ? 0 : a.length;if (null == a || 0 === a.length) return b.length;for (var c = 0, d = 0, e = 0, g = 0; c + d < b.length && c + e < a.length;) {
                if (b.charAt(c + d) == a.charAt(c + e)) g++;else for (var f = e = d = 0; 5 > f; f++) {
                    if (c + f < b.length && b.charAt(c + f) == a.charAt(c)) {
                        d = f;break;
                    }if (c + f < a.length && b.charAt(c) == a.charAt(c + f)) {
                        e = f;break;
                    }
                }c++;
            }return (b.length + a.length) / 2 - g;
        }, splitEmail: function splitEmail(b) {
            b = b.split("@");if (2 > b.length) return !1;for (var a = 0; a < b.length; a++) {
                if ("" === b[a]) return !1;
            }var c = b.pop(),
                d = c.split("."),
                e = "";if (0 == d.length) return !1;if (1 == d.length) e = d[0];else {
                for (a = 1; a < d.length; a++) {
                    e += d[a] + ".";
                }2 <= d.length && (e = e.substring(0, e.length - 1));
            }return { topLevelDomain: e, domain: c, address: b.join("@") };
        } } };

// function for easy setup
(function (jQuery) {
    jQuery.fn.setupMailCheck = function (msg_element) {
        var that = this;
        jQuery(msg_element).hide().html('Did you mean <a class="suggestedemail" style="cursor:pointer"><span class="address"></span>@<strong class="domain"></strong></a>?');
        jQuery(this).on('blur', function () {
            jQuery(this).mailcheck({
                // top 100 email domains
                domains: ["gmail.com", "yahoo.com", "hotmail.com", "yahoo.co.id", "aol.com", "ymail.com", "live.com", "rocketmail.com", "hotmail.co.uk", "me.com", "comcast.net", "mac.com", "yahoo.co.in", "msn.com", "yahoo.co.uk", "mail.ru", "abv.bg", "googlemail.com", "rediffmail.com", "sbcglobal.net", "yahoo.com.ph", "bigpond.com", "cox.net", "live.co.uk", "verizon.net", "yahoo.com.au", "yandex.ru", "hotmail.it", "yahoo.ca", "bellsouth.net", "aim.com", "gmx.de", "shaw.ca", "mail.com", "att.net", "hotmail.fr", "earthlink.net", "optusnet.com.au", "yahoo.fr", "btinternet.com", "yahoo.com.br", "rogers.com", "web.de", "live.com.au", "o2.pl", "libero.it", "gmx.com", "99designs.com", "yahoo.it", "live.ca", "in.com", "mail.bg", "optonline.net", "charter.net", "wp.pl", "163.com", "windowslive.com", "yahoo.es", "seznam.cz", "mailinator.com", "rambler.ru", "inbox.lv", "sympatico.ca", "yahoo.de", "freemail.hu", "telus.net", "bigpond.net.au", "gmx.net", "live.nl", "qq.com", "net.hr", "iinet.net.au", "ukr.net", "live.fr", "yahoo.com.ar", "live.com.mx", "yahoo.com.mx", "ovi.com", "inbox.com", "ntlworld.com", "live.it", "yahoo.com.tw", "hotmail.de", "hotmail.es", "yahoo.gr", "bk.ru", "yahoo.com.sg", "y7mail.com", "yahoo.com.my", "ya.ru", "inbox.ru", "live.in", "email.com", "facebook.com", "tpg.com.au", "sky.com", "juno.com", "gmx.at", "internode.on.net", "yahoo.in"],
                // top email tlds
                topLevelDomains: ["co.uk", "co.id", "com.au", "co.in", "com.br", "com.ph", "co.za", "net.au", "rr.com", "co.nz", "com.ar", "com.mx", "com.sg", "com.my", "edu.au", "com.tw", "ac.uk", "co.il", "on.net", "org.au", "co.cc", "co.jp", "com.vn", "org.uk", "com.tr", "com.hk", "net.nz", "gov.au", "com.cn", "mn.us", "com.pt", "me.uk", "id.au", "com.uy", "co.yu", "net.il", "net.mx", "com.cy", "co.kr", "net.id", "ltd.uk", "co.rs", "com.pk", "co.zw", "com.mk", "com.pl", "co.ke", "net.ba", "ac.id", "ac.in", "com.np", "com", "net", "id", "ca", "in", "ru", "edu", "org", "de", "it", "bg", "nl", "fr", "pl", "br", "ph", "za", "no", "dk", "es", "hk"],
                suggested: function suggested(element, suggestion) {
                    jQuery(that).data("lastsuggestion", suggestion.full);
                    jQuery(".address", msg_element).html(suggestion.address);
                    jQuery(".domain", msg_element).html(suggestion.domain);
                    jQuery(msg_element).slideDown();
                },
                empty: function empty(element) {
                    jQuery(msg_element).slideUp();
                }
            });
        });
        jQuery(".suggestedemail").on('click', function () {
            jQuery(that).val(jQuery(that).data("lastsuggestion"));
            jQuery(msg_element).slideUp();
        });
    };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(6);

function ButtonSpinner() {
    this.attributes({
        startOn: 'spinnerStart',
        endOn: 'spinnerStop',
        listenOn: document,
        autoStart: false,
        spinnerMarkup: '<span class="button__icon"><span class="spinner"></span></span>',
        buttonClass: 'button--icon-right'
    });

    this.spinnerStart = function (event, data) {
        var buttonInner = this.$node.find('.button__inner');
        var spinner = this.$node.find('.spinner');

        if (buttonInner.length > 0 && spinner.length === 0) {
            if (!this.$node.hasClass(this.attr.buttonClass)) {
                this.$node.addClass(this.attr.buttonClass);
            }
            buttonInner.append(this.attr.spinnerMarkup);
        }

        this.$node.attr('disabled', true);
        this.$node.attr('data-spinning', true);
    };

    this.spinnerStop = function (event, data) {
        var spinner = this.$node.find('.spinner');

        if (spinner.length > 0) {
            var buttonIcon = spinner.parent('.button__icon');

            if (buttonIcon.length > 0) {
                buttonIcon.remove();
            }

            this.$node.removeClass(this.attr.buttonClass);
        }

        this.$node.attr('disabled', false);
        this.$node.removeAttr('data-spinning');
    };

    this.after('initialize', function () {
        if (this.attr.autoStart === true) {
            this.spinnerStart();
        }

        this.on(this.attr.listenOn, this.attr.startOn, this.spinnerStart);
        this.on(this.attr.listenOn, this.attr.endOn, this.spinnerStop);
    });
}

exports.default = (0, _flightjs.component)(ButtonSpinner);

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Cookies.js - 1.2.3
 * https://github.com/ScottHamper/Cookies
 *
 * This is free and unencumbered software released into the public domain.
 */
(function (global, undefined) {
    'use strict';

    var factory = function (window) {
        if (typeof window.document !== 'object') {
            throw new Error('Cookies.js requires a `window` with a `document` object');
        }

        var Cookies = function (key, value, options) {
            return arguments.length === 1 ?
                Cookies.get(key) : Cookies.set(key, value, options);
        };

        // Allows for setter injection in unit tests
        Cookies._document = window.document;

        // Used to ensure cookie keys do not collide with
        // built-in `Object` properties
        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)
        
        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');

        Cookies.defaults = {
            path: '/',
            secure: false
        };

        Cookies.get = function (key) {
            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
                Cookies._renewCache();
            }
            
            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];

            return value === undefined ? undefined : decodeURIComponent(value);
        };

        Cookies.set = function (key, value, options) {
            options = Cookies._getExtendedOptions(options);
            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);

            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);

            return Cookies;
        };

        Cookies.expire = function (key, options) {
            return Cookies.set(key, undefined, options);
        };

        Cookies._getExtendedOptions = function (options) {
            return {
                path: options && options.path || Cookies.defaults.path,
                domain: options && options.domain || Cookies.defaults.domain,
                expires: options && options.expires || Cookies.defaults.expires,
                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
            };
        };

        Cookies._isValidDate = function (date) {
            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
        };

        Cookies._getExpiresDate = function (expires, now) {
            now = now || new Date();

            if (typeof expires === 'number') {
                expires = expires === Infinity ?
                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
            } else if (typeof expires === 'string') {
                expires = new Date(expires);
            }

            if (expires && !Cookies._isValidDate(expires)) {
                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
            }

            return expires;
        };

        Cookies._generateCookieString = function (key, value, options) {
            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
            options = options || {};

            var cookieString = key + '=' + value;
            cookieString += options.path ? ';path=' + options.path : '';
            cookieString += options.domain ? ';domain=' + options.domain : '';
            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
            cookieString += options.secure ? ';secure' : '';

            return cookieString;
        };

        Cookies._getCacheFromString = function (documentCookie) {
            var cookieCache = {};
            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];

            for (var i = 0; i < cookiesArray.length; i++) {
                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);

                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
                }
            }

            return cookieCache;
        };

        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
            var separatorIndex = cookieString.indexOf('=');

            // IE omits the "=" when the cookie value is an empty string
            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;

            var key = cookieString.substr(0, separatorIndex);
            var decodedKey;
            try {
                decodedKey = decodeURIComponent(key);
            } catch (e) {
                if (console && typeof console.error === 'function') {
                    console.error('Could not decode cookie with key "' + key + '"', e);
                }
            }
            
            return {
                key: decodedKey,
                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
            };
        };

        Cookies._renewCache = function () {
            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
            Cookies._cachedDocumentCookie = Cookies._document.cookie;
        };

        Cookies._areEnabled = function () {
            var testKey = 'cookies.js';
            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
            Cookies.expire(testKey);
            return areEnabled;
        };

        Cookies.enabled = Cookies._areEnabled();

        return Cookies;
    };
    var cookiesExport = (global && typeof global.document === 'object') ? factory(global) : factory;

    // AMD support
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return cookiesExport; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    // CommonJS/Node.js support
    } else if (typeof exports === 'object') {
        // Support Node.js specific `module.exports` (which can be a function)
        if (typeof module === 'object' && typeof module.exports === 'object') {
            exports = module.exports = cookiesExport;
        }
        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
        exports.Cookies = cookiesExport;
    } else {
        global.Cookies = cookiesExport;
    }
})(typeof window === 'undefined' ? this : window);

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    this.resetValidationErrors = function (e, data) {
        this.$node.find('.field[data-field-error]').removeAttr('data-field-error');
        this.$node.find('.field__validation, .fieldset__validation').empty();
    };

    this.checkForValidationErrors = function (e, data) {
        if (data.status === 'validation') {
            var component = this;

            _jquery2.default.each(data.content, function (i, v) {
                component.displayErrorsForField((0, _jquery2.default)('[name="' + i + '"]'), v);
            });

            this.trigger('errorsPopulated');
        }
    };

    this.displayErrorsForField = function ($input, errors) {
        if (!_jquery2.default.isArray(errors)) {
            errors = [errors];
        }
        $input.closest('.field').attr('data-field-error', '');

        var $validationContainer = (0, _jquery2.default)('#' + $input.data('validationMessageContainer'));
        var validationContainerType = $validationContainer.data('validationType');
        var component = this;

        if ($validationContainer.length) {
            _jquery2.default.each(errors, function (i, error) {
                $validationContainer.append(component.template(component.errorTemplate[validationContainerType], {
                    error_message: error // eslint-disable-line camelcase
                }));
            });
        }
    };

    this.template = function (template, args) {
        _jquery2.default.each(args, function (i, v) {
            i = '%%' + i + '%%';
            template = template.replace(i, v);
        });
        return template;
    };

    this.attributes({
        errorTemplate: {
            field: '',
            fieldset: ''
        }
    });

    this.after('initialize', function () {
        this.errorTemplate = {
            field: this.$node.data('fieldErrorTemplate'),
            fieldset: this.$node.data('fieldsetErrorTemplate')
        };

        this.on('asyncFormProcessing', this.resetValidationErrors);
        this.on('asyncFormSuccess', this.checkForValidationErrors);
    });
};

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })

},[1815]);


// WEBPACK FOOTER //
// launch/layout-6296712e8ff40bd9f480.js